<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName + ' tabulator-parent'">
      <div class="row">
        <div class="col-md-12">
          <h3>{{ _('Vouchers') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition name="fade" mode="out-in">
          <div v-bind="tabPanel('vouchers')" class="tab-pane active" id="vouchers" v-if="isTabActive('vouchers')" key="vouchers">
            <div class="row">
              <div class="col-md-3 col-sm-4 filtercol">
                <div class="form-group">
                  <div class="input-group">
                    <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-9 col-sm-8 filtercol newbuttoncol">
                <button class="pull-right newSelector btn btn-success addbutton" type="button" v-on:click="createNewDialog()"><i class="fa fa-fw fa-plus"></i> {{ _('Create new...') }}</button>
              </div>
            </div>	
            <Datatable :url="vouchersUrl" :search="search" :options="tableOptions" ref="datatableVouchers" v-on:data="tableEvent" :style="isModal ? 'height: 70dvh; min-height: 200px;' : ''" />
          </div>
        </transition>
      </div>
    </div>
    <nav class="modal-footer" v-if="isModal">
      <div class="button-row aling-right">
        <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable, ModalVoucherDetails as VoucherDetails } from '#components'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      search: '',
      activeTab: 'vouchers',
      tableOptions: {
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          responsive: 0
        },
        {
          title: _('Value'),
          field: 'value',
          widthGrow: 2,
          formatter: $this.numberFormatter()
        },
        {
          title: _('Value card'),
          field: 'valuecard',
          widthGrow: 2,
          formatter: $this.yesNoFormatter()
        },
        ],
         initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editVoucher(id, name)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'vouchers', label: this._('Vouchers') }
      ])
    },
    versionStr () {
      return '&locale=' + this.locale + '&version=' + this.version
    },
    vouchersUrl () {
      return this.baseDomain + this.shopId + '/vouchers.json?apikey=' + this.apiKey + '&rawformat=true'
    }
  },
  methods: {
    createNewDialog () {
      this.showDialog({
        title: this._('Create new voucher'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name'],
            handler: (data) => {
              this.createNew(data)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          },
        ]
      })
    },
    async createNew (data) {
      let response
      const d = {
        name: data.name,
        description: data.description
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/vouchers.json?apikey=' + this.apiKey, d)
      } catch(e) {
        this.showError(e)
        return
      }
    },
    async editVoucher (id, name) {
      this.showModal('voucherdetails', VoucherDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              modal: true,
              voucherId: id
            }
          }
        },
        events: {
          save: () => {}
        },
        handlers: {},
        width: 1000
      })
    },
    async modify (id, data) {
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/vouchers/' + id + '.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
    },
    reload () {
      if (this.$refs.datatableVouchers) {
        this.$refs.datatableVouchers.reload()
      }
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['voucherUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>